
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Products } from "@components/products";
import { PvcWindowContent } from "@components/pvc-window-content";
import { NextSeo } from "@components/seo";
import { VekaColors } from "@components/veka-colors";
import { PVC } from "@consts/ppvc";
import type { IProduct } from "@type/products";
import { getAllPvcByParent, getAllPvcPathsById, getProductLocaleRedirect, getPvcById, } from "@utils/get-products";
import type { GetStaticPaths, GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
interface IProductCard {
    product: IProduct;
    products: IProduct[];
}
const Product: NextPage<IProductCard> = ({ product, products }) => {
    const { t } = useTranslation("pvc");
    return (<>
      <NextSeo title={`${product?.title} ${t("windows.veka.title")}`}/>
      <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
        <PvcWindowContent producer="veka" product={product}/>
        {/* hide colors on aluconnect product page */}
        {product.slug !== "aluconnect" && <VekaColors />}
        {products && <Products productPage products={products} showId/>}
      </div>
    </>);
};
export const getStaticPaths: GetStaticPaths = async () => {
    const PATHS_IDS = Object.values(PVC.WINDOWS.VEKA);
    const { paths: path } = await getAllPvcPathsById(PATHS_IDS);
    const paths = path.map((p: {
        slug: string;
        databaseId: string;
        language: {
            code: string;
        };
    }) => ({
        locale: p.language.code.toLowerCase(),
        params: {
            slug: `${p.slug}-${p.databaseId}`,
        },
    }));
    // console.log('paths', paths);
    // const paths = [
    //   { params: { slug: 'swingline-610' }, locale: 'pl' },
    //   { params: { slug: 'perfectline-zaokraglony-606' }, locale: 'pl' },
    //   { params: { slug: 's-line-603' }, locale: 'pl' },
    //   { params: { slug: 'perfectline-80' }, locale: 'pl' },
    //   { params: { slug: 'revento-76' }, locale: 'pl' },
    //   { params: { slug: 'softline-76-md-72' }, locale: 'pl' },
    //   { params: { slug: 'artline-40' }, locale: 'pl' },
    //   { params: { slug: 'softline-82-md-36' }, locale: 'pl' },
    // ];
    return {
        fallback: "blocking",
        paths,
    };
};
const getStaticProps: GetStaticProps = async (context) => {
    const slug = context.params?.slug as string;
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PRODUCT_ID = slug.split("-").pop();
    const { product } = await getPvcById(PRODUCT_ID, LOCALE);
    if (!product) {
        return { notFound: true };
    }
    const redirect = getProductLocaleRedirect(product, LOCALE, "/pvc/windows/veka");
    if (redirect) {
        return { redirect };
    }
    const { products } = await getAllPvcByParent(PVC.WINDOWS.VEKA[LOCALE as keyof typeof PVC.WINDOWS.VEKA], LOCALE);
    return {
        props: {
            product,
            products,
        },
    };
};
export default Product;

    async function __Next_Translate__getStaticProps__1a19cd2c0b6__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/windows/veka/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2c0b6__ as getStaticProps }
  